module.exports = __webpack_public_path__ + "img/Pic_PT_Tc_UpD_a.2300f76f.png";